import { useState, useEffect } from 'react';
import style from './register.module.css'

function Reload({page , setPage}){


    return(
       <div className={style.authbox}>
            <div className={style.flexauth}>
                <h4>Восстановить пароль</h4>
                <h2>🔓</h2>
            </div>
            <input className={style.inputb} placeholder='Логин' />
            <button className={`${style.btngred}`} onClick={() => {
               
            }}>Далее</button>
            <span onClick={() => {
               setPage(1)
            }}>Помню пароль</span>
        </div>
     );
}

export default Reload;